angular.module('bmsApp.accounting').controller('PaymentReceiptFormCtrl', function ($scope,
																				   $q,
																				   $filter,
																				   ConfigService,
																				   CustomerSvc,
																				   PaymentTypeSvc,
																				   AccountingSvc) {

	$scope.config = ConfigService.config;
	$scope.datePickerBasicConfig = angular.copy($scope.config.datePicker.basic);
	$scope.datePickerBasicConfig.options.parentEl = '.modal-content';

	angular.extend($scope.prForm, {
		ready: false,
		loadingOptions: true,
		loadingInvoices: false,
		processing: false,
		includeInactive: $scope.isTG() ? true : false,
		customerPayment: {
			payment_date: moment().format('YYYY-MM-DD'),
			received_amount: 0,
			amount_remaining: 0,
			oldBalance: 0,
			newBalance: 0
		},
		init: function () {
			var initPromises = {
				customerOptions: $scope.prForm.getCustomerOptions(),
				paymentTypeOptions: PaymentTypeSvc.options()
			};
			$q.all(initPromises).then(function (responses) {
				if (angular.isObject($scope.prModal.customer) === true) {
					$scope.prForm.customerPayment.customer = $scope.prModal.customer;
				}
				else {
					$scope.prForm.customerOptions = responses.customerOptions.data.options;
				}
				$scope.prForm.paymentTypeOptions = responses.paymentTypeOptions.data.options;
				$scope.prForm.loadingOptions = false;
				$scope.prForm.ready = true;
				if (angular.isObject($scope.prForm.customerPayment.customer)) {
					$scope.prForm.onCustomerChange();
				}
			});
		},
		getCustomerOptions: function() {
			let statuses = ($scope.prForm.includeInactive) ? [1,3,4] : [3]; // pending|active|inactive or inactive
			return CustomerSvc.options({filter: {status: statuses, selectJobReferences: true}})
		},
		includeInactiveClick: function() {
			$scope.prForm.getCustomerOptions().then((response) => {
				$scope.prForm.customerOptions = response.data.options;
			});
		},
		onCustomerChange: function () {
			$scope.prForm.ready = false;
			if (angular.isObject($scope.prForm.customerPayment.customer)) {
				$scope.prForm.loadingInvoices = true;
				var promises = {
					outstandingInvoicesPromise: AccountingSvc.outstandingCustomerInvoices($scope.prForm.customerPayment.customer.id),
					customerBalance: CustomerSvc.getBalance($scope.prForm.customerPayment.customer.id)
				};
				$q.all(promises).then(function (responses) {
					$scope.prForm.customerPayment.invoices = [];
					$scope.prForm.customerPayment.invoices = responses.outstandingInvoicesPromise.data.invoices;
					console.log($scope.prForm.customerPayment.invoices);
					angular.forEach($scope.prForm.customerPayment.invoices, function (value) {
						value.allocation = 0;
					});
					$scope.prForm.customerPayment.oldBalance = responses.customerBalance.data.credit_amount;
					if (angular.isObject($scope.prModal.invoicePrototype)) {
						if ($scope.prModal.invoicePrototype.id) {
							let matchingInvoices = $filter('filter')(
								$scope.prForm.customerPayment.invoices,
								{
									id: $scope.prModal.invoicePrototype.id
								},
								true,
							);
							angular.forEach(matchingInvoices, (invoice) => {
								let index = $scope.prForm.customerPayment.invoices.indexOf(invoice);
								$scope.prForm.customerPayment.invoices.splice(index, 1);
								// Remove replace invoice from total
								$scope.prForm.customerPayment.oldBalance += invoice.total_gross;
							});
						}
						$scope.prForm.customerPayment.invoices.splice(0, 0, angular.extend($scope.prModal.invoicePrototype, {
							allocation: 0
						}));
						$scope.prForm.customerPayment.oldBalance -= $scope.prModal.invoicePrototype.outstanding;
					}
					if (angular.isObject($scope.prModal.additionalInvoicePrototype)) {
						$scope.prForm.customerPayment.invoices.splice(1, 0, angular.extend($scope.prModal.additionalInvoicePrototype, {
							allocation: 0
						}));
						$scope.prForm.customerPayment.oldBalance -= $scope.prModal.additionalInvoicePrototype.outstanding;
					}
					// re-distribute the payment
					$scope.prForm.distributePayment();
					$scope.prForm.calculateNewBalance();
					$scope.prForm.loadingInvoices = false;
					$scope.prForm.ready = true;
				});
			}
			else {
				$scope.prForm.customerPayment.invoices = [];
				$scope.prForm.ready = true;
			}
		},
		onReceivedAmountChange: function () {
			$scope.prForm.distributePayment();
			$scope.prForm.calculateNewBalance();
			$scope.prForm.calculateReceivedAllocationComparison();
		},
		onAllocationChange: function (invoice) {
			if (isNaN(invoice.allocation)) {
				invoice.allocation = 0;
			}
			$scope.prForm.calculateReceivedAllocationComparison();
		},
		distributePayment: function () {
			var amountRemaining = $scope.prForm.customerPayment.received_amount;
			angular.forEach($scope.prForm.customerPayment.invoices, function (invoice) {
				if (amountRemaining >= invoice.outstanding) {
					invoice.allocation = precisionRound(invoice.outstanding, 2);
					amountRemaining -= invoice.outstanding;
				}
				else {
					invoice.allocation = precisionRound(amountRemaining, 2);
					amountRemaining -= amountRemaining;
				}
			});
		},
		calculateNewBalance: function () {
			console.info('calculate balance');
			var newBalance = $scope.prForm.customerPayment.oldBalance + $scope.prForm.customerPayment.received_amount + ($scope.prForm.customerPayment.customer.balance_adjustment || 0);
			console.info('calculated balance!');
			$scope.prForm.customerPayment.newBalance = newBalance;
		},
		calculateReceivedAllocationComparison: function () {
			var allocation = 0;
			angular.forEach($scope.prForm.customerPayment.invoices, function (invoice) {
				allocation += invoice.allocation;
			});
			allocation = precisionRound(allocation, 2);
			$scope.prForm.customerPayment.amount_remaining = $scope.prForm.customerPayment.received_amount - allocation;
		},
		isCheque: function () {
			if (angular.isObject($scope.prForm.customerPayment.payment_type)) {
				return $scope.prForm.customerPayment.payment_type.value.toLowerCase().indexOf('cheque') > -1;
			}
			else {
				return false;
			}
		},
		formvalidatorconfig: {
			submitHandler: function () {
				if ($scope.prForm.customerPayment.received_amount < 0.01) {
					$scope.prForm.errors = [
						'Amount received must be greater than £0.00'
					];
					return;
				}

				$scope.prModal.instance.close($scope.prForm);
			},
			errorPlacement: function (error) {
				error.appendTo('#payment-receipt-errors');
			},
			errorContainer: '#payment-receipt-errors'
		}
	});

	$scope.prForm.init();

});
